import { createFileRoute } from '@tanstack/react-router'

import EditCriteriaContent from '../../-components/criteria/$itemId'

export const Route = createFileRoute(
  '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/$itemId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { scorecardId, itemId } = Route.useParams()
  return <EditCriteriaContent scorecardId={scorecardId} itemId={itemId} />
}
